<template>
  <div id="app">
    <nav-bar-mobile v-if="(isContentFullyMounted && !$store.state.isMobileHomeVisible) || (isNotInHomePage)" />
    <nav-bar-pc v-if="(isContentFullyMounted && !$store.state.isMobileHomeVisible) || (isNotInHomePage)" />
    <router-view />
    <onesti-footer v-if="(isContentFullyMounted && !$store.state.isMobileHomeVisible) || (isNotInHomePage)" />
    <whatsapp-button :phone="phone" />
  </div>
</template>

<script>
import NavBarPc from '@/components/nav-bar-pc'
import NavBarMobile from '@/components/nav-bar-mobile'
import WhatsappButton from '@/components/whatsapp-button'
import { getPhoneNumber } from '@/utils'
const OnestiFooter = () => import('@/components/onesti-footer')

export default {
  name: 'App',
  components: {
    WhatsappButton,
    NavBarPc,
    NavBarMobile,
    OnestiFooter
  },
  data () {
    return {
      wasRedirectBasedOnLanguage: false,
      isContentFullyMounted: false,
      isNotInHomePage: false
    }
  },
  computed: {
    phone () {
      return getPhoneNumber(true)
    },
    routeName () {
      return this.$route.name
    },
    isMobileHomeVisible () {
      return this.$store.state.isMobileHomeVisible
    }
  },
  methods: {
    languageRedirect () {
      if (this.$route.name === 'home') {
        let matchedLanguage
        const languagesArr = ['en', 'pt', 'es', 'zh']
        const browserLanguage = navigator.language
        languagesArr.every(lang => {
          if (browserLanguage.includes(lang)) {
            matchedLanguage = lang
            return false
          }
          return true
        })
        if (matchedLanguage !== 'pt') {
          if (matchedLanguage === 'zh') matchedLanguage = 'cn'
          this.$router.push({
            name: 'home-lang',
            params: {
              lang: matchedLanguage
            }
          })
          this.wasRedirectBasedOnLanguage = true
        }
      }
    }
  },
  watch: {
    routeName (name) {
      if (!this.wasRedirectBasedOnLanguage) this.languageRedirect()
      const pagesName = ['modern-slavery-lang', 'green-politic-lang', 'general-politic-lang', 'anti-corruption-lang', 'legal-advice-lang']
      let result
      this.isNotInHomePage = pagesName.every(page => {
        if (page === name) {
          result = true
          return false
        }
        return true
      })
      this.isNotInHomePage = result
      this.$store.dispatch('changeNavBarStatus', 'visible')
    },
    isMobileHomeVisible (isVisible) {
      this.$store.dispatch('changeNavBarStatus', isVisible ? 'invisible' : 'visible')
    }
  },
  created () {
    this.$store.dispatch('decideWhatHomeToRender')
    this.$root.$on('content-fully-mounted', () => { this.isContentFullyMounted = true })
  },
  comments: true
}
</script>

<style lang="sass">
@import 'assets/styles/tailwind.postcss'
@tailwind utilities
body
  @apply m-0

#app
  @apply font-sans

.scn
  @apply relative bg-white px-3 py-5
  @screen sm-l
    @apply px-5
  @screen md
    @apply px-3
  &__content
    @apply leading-normal text-grey-darker mx-auto mt-6
    max-width: 1000px
    letter-spacing: 1px
  &--mobile
    @apply p-0 pb-2
  &--grey
    @apply bg-grey-light
  &--black
    @apply bg-grey-darker
    .scn-header
      @apply text-white
    .scn__content
      @apply text-white
  &--dark
    @apply bg-black
    .scn-header
      @apply text-white
    .scn__content
      @apply text-white
  &--pink
    @apply bg-pink

.two-col-content
  @apply flex flex-col
  @screen md
    @apply flex-row
  &__col
    @screen md
      @apply w-1/2
    &--expandable
      @apply w-full
      @screen lg
        @apply w-1/2
  &--sm-l
    @screen sm-l
      @apply flex-row
    .two-col-content
      &__col
        @screen sm-l
          @apply w-1/2

/* purgecss start ignore */
.navigation-carousel
  .VueCarousel
    &-navigation-next, &-navigation-prev
      top: 60px !important
      @screen md
        top: 100px !important
      &::after
        @apply absolute w-4 h-4
    &-navigation-next
      &::after
        content: url("~@/assets/images/icons/chevron-right-solid.svg")
    &-navigation-prev
      &::after
        content: url("~@/assets/images/icons/chevron-left-solid.svg")

.cards-carousel
  .VueCarousel
    &-slide
      @apply inline-flex justify-center py-2
      & > *
        @apply block

.cases-carousel
  .VueCarousel
    &-navigation-button
      @apply -mt-3

.testimony-carousel
  .VueCarousel
    &-slide
      @apply pt-2 px-4
    &-dot-container
      margin-top: 0 !important
    &-navigation-button
      @apply mt-3
    &-navigation-next
      &::after
        content: url("~@/assets/images/icons/chevron-right-solid-white.svg")
    &-navigation-prev
      &::after
        content: url("~@/assets/images/icons/chevron-left-solid-white.svg")
/* purgecss end ignore */
</style>
